import script from "./PublicReadingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicReadingPage.vue?vue&type=script&setup=true&lang=js"

import "./PublicReadingPage.vue?vue&type=style&index=0&id=768aef58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768aef58"]])

export default __exports__